import React from 'react';

export const TimesheetMobileCard = ({ report, darkMode }) => {
  const date = new Date(report.submittedAt).toLocaleDateString('ru-RU');
  
  return (
    <div className={`p-4 mb-3 rounded-lg border ${
      darkMode ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'
    }`}>
      <div className="mb-3">
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">Проект</p>
        <p className="text-sm font-medium break-words">{report.project}</p>
      </div>
      
      <div className="grid grid-cols-3 gap-3">
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Дни</p>
          <p className="text-sm">{report.days} дн.</p>
        </div>
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Процент</p>
          <p className={`text-sm font-bold ${
            parseFloat(report.percentage) > 25
              ? 'text-red-600 dark:text-red-400'
              : 'text-green-600 dark:text-green-400'
          }`}>
            {report.percentage}%
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Дата</p>
          <p className="text-sm">{date}</p>
        </div>
      </div>
    </div>
  );
};